import React, { useMemo } from 'react';

import { AdServer, type LayoutType } from '@schibsted-nmp/advertising-shared';

import type { PositionData } from './useSearchPositionInstruction.js';
import { AdvertisingAfsWebComponent } from '../components/AdvertisingAfsWebComponent.js';
import { AdvertisingWebComponent } from '../components/AdvertisingWebComponent.js';

export function useAdComponents(
  layoutType: LayoutType,
  positionData: ReadonlyArray<PositionData>
) {
  return useMemo(
    () =>
      positionData.map(({ placementId, position, adServer }, index) => {
        if (adServer === AdServer.Afs) {
          return {
            element: <AdvertisingAfsWebComponent placementId={placementId} />,
            position
          };
        }

        return {
          element: (
            <AdvertisingWebComponent
              placementId={placementId}
              adIndex={index}
              key={`${placementId}${index}`}
              initialLayoutType={layoutType}
            />
          ),
          position
        };
      }),
    [positionData]
  );
}
